import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { subscribe } from 'alfa';
import { Alert, Button, Form, Input, Select, Typography, message } from 'antd';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import uuidv4 from 'uuid/v4';

import AccountTypeRepo from '../../repository/account-type';
import Link from '../../components/link';
import AccountRepo from '../../repository/account';
import URL from '../../helpers/url';

const { Title } = Typography;

const regionId = (productId) => {
  const [, region = 'mxn'] = productId.split('_');
  return region.toUpperCase();
};

const AccountNew = withTranslation()(({ form: { getFieldDecorator, setFieldsValue, validateFields }, business, t, history, ...props }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [countryTypes, setCountryTypes] = useState([]);
  const types = AccountTypeRepo.all();

  const onCountryChange = (country) => {
    setCountryTypes(types[country].types);
    setFieldsValue({
      type: null,
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    validateFields(async (validateError, { alias, type }) => {
      if (validateError) { return; }
      setLoading(true);
      const accountCreation = {
        business,
        alias,
        product_id: type,
        id: uuidv4(),
      };

      try {
        await AccountRepo.createNew(accountCreation);
        message.success(t('success.creating_account'));
        history.push(
          URL('/accounts', props),
          { newAccount: {
            ...accountCreation,
            balance: { available: 0, at: (new Date()).toISOString() },
            region_id: regionId(type),
          } },
        );
      } catch (createError) {
        console.error('ERROR: AccountNew onSubmit(): ', createError); // eslint-disable-line no-console
        message.error(t('error.creating_account'));
        setError((createError.response) ? createError.response.data.message : createError.message);
        setLoading(false);
      }
    });
  };

  const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 },
  };

  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 12,
        offset: 6,
      },
    },
  };

  return (
    <>
      <Title level={3}>{t('create_account')}</Title>
      <Form {...formItemLayout} onSubmit={onSubmit}>
        {(error === null) ? '' : (
          <Alert
            message={t('error.creating_account')}
            description={error}
            type="error"
            showIcon
            banner
            style={{ margin: '30px -20px 30px -20px' }}
          />
        )}

        <Form.Item label={t('account.account_alias')}>
          {getFieldDecorator('alias', {
            rules: [{
              required: true,
              message: t('account.required.alias'),
            }],
          })(
            <Input name="alias" />,
          )}
        </Form.Item>
        <Form.Item label={t('account.account_country')}>
          {getFieldDecorator('country', {
            rules: [{
              required: true,
              message: t('account.required.country'),
            }],
          })(
            <Select style={{ width: 150 }} onChange={onCountryChange}>
              {types.map((type, index) => (
                <Select.Option key={type.country} value={index}>{type.country}</Select.Option>
              ))}
            </Select>,
          )}
        </Form.Item>
        <Form.Item label={t('account.account_type')}>
          {getFieldDecorator('type', {
            rules: [{
              required: true,
              message: t('account.required.type'),
            }],
          })(
            <Select style={{ width: 150 }}>
              {countryTypes.map((type) => (
                <Select.Option key={type.id}>
                  {type.name}
                </Select.Option>
              ))}
            </Select>,
          )}
        </Form.Item>
        <Form.Item {...tailFormItemLayout}>
          <Button loading={loading} type="primary" htmlType="submit">{t('create')}</Button>&nbsp;
          <Link to="/accounts" className="ant-btn">{t('cancel')}</Link>
        </Form.Item>
      </Form>
    </>
  );
});

AccountNew.propTypes = {
  business: PropTypes.object,
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    validateFields: PropTypes.func,
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  t: PropTypes.func,
  getFieldDecorator: PropTypes.func,
};

export default withRouter(subscribe(Form.create({ name: 'account-new' })(AccountNew), ['business']));
